import { Box, Link, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { useEffect, useState } from "react"
import { getFileList, getFileMetadata } from "../api/api"
import { getDownloadURL, getStorage, ref } from "firebase/storage"
import dayjs from "dayjs"

const Registros = () => {

    const storage = getStorage()

    const [personId, setPersonId] = useState('')
    const [fileList, setFileList] = useState([])
    const [metadataList, setMetadataList] = useState([])

    const downloadFile = (refPath) => {
        getDownloadURL(ref(storage, refPath))
            .then((url) => {
                // This can be downloaded directly:
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = (event) => {
                    const blob = xhr.response;
                };
                xhr.open('GET', url);
                xhr.send();

                window.location = url
            })
    }

    useEffect(() => {

        const getFileListAsync = async () => {
            setFileList(await getFileList());
        }

        getFileListAsync()

    }, [])


    useEffect(() => {

        const getMetadataList = async () => {
            setMetadataList(await getFileMetadata(personId));
        }

        if (personId !== '') {
            getMetadataList()
        }

    }, [personId])

    return (
        <Box>
            <Modal open={personId !== ''} onClose={() => setPersonId('')}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Table>
                        <TableHead>
                            <TableCell>
                                Nombre
                            </TableCell>
                            <TableCell>
                                Fecha de creación
                            </TableCell>
                        </TableHead>
                        <TableBody>
                            {
                                metadataList.map(x => {

                                    let name = x.name
                                    const split = name.split("/")

                                    if (split && split.length > 0) {
                                        name = split[2]
                                    }

                                    return (
                                        < TableRow >
                                            <TableCell>
                                                {name}
                                            </TableCell>
                                            <TableCell>
                                                {dayjs(x.created_date).format('YYYY-MM-DD HH:mm:ss')}
                                            </TableCell>
                                            <TableCell>
                                                <Link sx={{
                                                    cursor: 'pointer'
                                                }}
                                                    onClick={() => downloadFile(x.name)}>
                                                    Descargar
                                                </Link>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }

                                )
                            }

                        </TableBody>
                    </Table>
                </Box>
            </Modal >
            <Table>
                <TableHead>
                    <TableCell>
                        Identificación
                    </TableCell>
                    <TableCell>
                        Correo Electronico
                    </TableCell>
                    <TableCell>
                        Mesa
                    </TableCell>
                    <TableCell>
                        Autores
                    </TableCell>
                    <TableCell>
                        Fecha de creación
                    </TableCell>
                </TableHead>
                <TableBody>
                    {
                        fileList.map(x =>
                            <TableRow>
                                <TableCell>
                                    <Link onClick={() => setPersonId(x.user_id)} sx={{
                                        cursor: 'pointer'
                                    }}>
                                        {x.user_id}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    {x.user_email}
                                </TableCell>
                                <TableCell>
                                    {x.user_table}
                                </TableCell>
                                <TableCell>
                                    {x.user_authors}
                                </TableCell>
                                <TableCell>
                                    {dayjs(x.user_created).format('YYYY-MM-DD HH:mm:ss')}
                                </TableCell>
                            </TableRow>
                        )
                    }

                </TableBody>
            </Table>
        </Box >
    )
}

export default Registros